import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * Quiet fine print for compliance disclaimers: info icon + caption, no
 * container. Deliberately unboxed so a disclaimer never gets visual parity
 * with the content cards it qualifies. One vocabulary for every disclaimer.
 */
export default function DisclaimerNote({ children, sx }: { children: ReactNode; sx?: object }) {
  return (
    <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'flex-start', ...sx }}>
      <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary', mt: '1px', flexShrink: 0 }} />
      <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
        {children}
      </Typography>
    </Box>
  );
}
